<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.61 8.98a1 1 0 0 1-.16-.33.78.78 0 0 1 0-.3 1 1 0 0 1 .16-.33C2.36 6.84 4.6 3.83 8 3.83c3.4 0 5.64 3 6.39 4.2.09.14.13.21.16.32.02.08.02.22 0 .3-.03.11-.07.18-.16.33-.75 1.18-2.99 4.19-6.39 4.19-3.4 0-5.64-3-6.39-4.2Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
